<div class="member-page p-4" *ngIf="member">
	<div class="flex items-center mb-4 border-b pb-3">
		<nz-avatar nzSize="large" nzIcon="user"></nz-avatar>
		<div class="ml-3">
			<h2 class="text-xl font-bold mb-1">{{ member.name }} {{ member.surname }}</h2>
			<p class="text-gray-500">
				Member ID: {{ member.id }} • Status: <i class="text-success">Active</i>
			</p>
			<p class="text-gray-400 text-sm">
				Joined: {{ member.createdAt | date }}
			</p>
		</div>
		<div class="ml-auto">
			<a nz-button nzType="default" class="mr-2" [routerLink]="['/member',member.id,'edit']">Edit</a>
		</div>
	</div>

	<!-- Tabs -->
	<nz-tabset nzType="card">
		<nz-tab nzTitle="Details">
			<app-member-view-details [member]="member"></app-member-view-details>
		</nz-tab>

		<nz-tab nzTitle="Membership History">
			<app-member-view-memberships [member]="member"></app-member-view-memberships>
		</nz-tab>

		<nz-tab nzTitle="Tickets">
			<app-member-view-claims [member]="member"></app-member-view-claims>
		</nz-tab>
	</nz-tabset>
</div>
